import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaReservationList } from '@/service/tuina'

export const fetchTuinaReservationList = createAsyncThunk(
  'tuinaReservationList/fetchTuinaReservationList',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaReservationList(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载预约失败'
      )
    }
  }
)

const reservationListSlice = createSlice({
  name: 'tuinaReservationList',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaReservationList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaReservationList.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || {}
      })
      .addCase(fetchTuinaReservationList.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default reservationListSlice.reducer
